
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M29.75 10.286h-28A1.732 1.732 0 000 12v34.286c.01.956.793 1.724 1.75 1.714h28c.957.01 1.74-.758 1.75-1.714V12a1.732 1.732 0 00-1.75-1.714zM28 44.57H3.5V13.714H28V44.57zM42 1.714V36a1.732 1.732 0 01-1.75 1.714H35a1.716 1.716 0 110-3.429h3.5V3.429H14v3.428a1.75 1.75 0 01-3.5 0V1.714A1.732 1.732 0 0112.25 0h28c.957-.01 1.74.757 1.75 1.714zM10.5 20.571a1.732 1.732 0 011.75-1.714H14v-1.714a1.75 1.75 0 013.5 0v1.714h1.75a1.715 1.715 0 11.083 3.429H17.5V24a1.75 1.75 0 11-3.5 0v-1.714h-1.75a1.732 1.732 0 01-1.75-1.714v-.001zm-1.75 8.572a1.732 1.732 0 011.75-1.715H21a1.717 1.717 0 011.756 1.674 1.717 1.717 0 01-1.673 1.756H10.5a1.733 1.733 0 01-1.75-1.715zm0 5.142a1.732 1.732 0 011.75-1.715H21a1.715 1.715 0 11.083 3.43H10.5a1.732 1.732 0 01-1.75-1.715zm0 5.143a1.732 1.732 0 011.75-1.714H21a1.716 1.716 0 110 3.429H10.5a1.731 1.731 0 01-1.75-1.713v-.002z"}})])
          )
        }
      }
    